var _module_exports = "<div id=\"schedule-email-text-editor\" class=\"editor ql-container ql-snow\">\n</div>\n";;
var path = '/app/src/client/components/schedule-email/quill-editor/quill-editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;